import LoadingSpinner from './LoadingSpinner'

import { withStyles } from '@material-ui/styles'
import { compose, withHandlers } from 'recompose'
import styles from './styles'

export default compose(
  withStyles(styles),
  withHandlers({
    
  }),
)(LoadingSpinner)
